module.exports = __webpack_public_path__ + "img/symbol_2.ecd5d04e.png";